// extracted by mini-css-extract-plugin
export var growableInput = "_9l-0";
export var tagContainer = "_9l-2";
export var textInput = "_9l-1";